import React from "react";

export function LoanComparisonIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 55.19 58.87"
      width="30"
      height="30"
      {...props}
    >
      <polygon
        className="cls-1"
        points="55.19 57.87 46.41 57.87 46.41 56.87 54.19 56.87 54.19 21.72 47.91 15 45.41 15 45.41 14 48.34 14 55.19 21.33 55.19 57.87"
      />
      <polygon
        className="cls-1"
        points="40.49 58.37 25.21 58.37 25.21 56.37 38.49 56.37 38.49 10.92 32.49 4.5 25.21 4.5 25.21 2.5 33.36 2.5 40.49 10.13 40.49 58.37"
      />
      <g>
        <polygon
          className="cls-1"
          points="18.78 58.87 0 58.87 0 55.87 15.78 55.87 15.78 47.92 18.78 47.92 18.78 58.87"
        />
        <polygon
          className="cls-1"
          points="18.78 14.48 15.78 14.48 15.78 9.12 10.06 3 0 3 0 0 11.37 0 18.78 7.93 18.78 14.48"
        />
      </g>
      <g>
        <path
          className="cls-1"
          d="m16.52,43.92c-7.32,0-13.28-5.96-13.28-13.28s5.96-13.28,13.28-13.28,13.28,5.96,13.28,13.28-5.96,13.28-13.28,13.28Zm0-23.56c-5.67,0-10.28,4.61-10.28,10.28s4.61,10.28,10.28,10.28,10.28-4.61,10.28-10.28-4.61-10.28-10.28-10.28Z"
        />
        <rect
          className="cls-1"
          x="26.72"
          y="37.23"
          width="3"
          height="8.66"
          transform="translate(-21.12 32.12) rotate(-45)"
        />
      </g>
    </svg>
  );
}
